"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MultiSelectMenuItem_1 = __importDefault(require("./MultiSelectMenuItem"));
exports.default = (function (_a) {
    var items = _a.items, value = _a.value, handlerChange = _a.handlerChange, showCheckbox = _a.showCheckbox, classes = _a.classes, renderItem = _a.renderItem;
    var RowRenderer = function (_a) {
        var key = _a.key, index = _a.index, style = _a.style;
        if (!items) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        var item = items[index];
        var selected = !!value[item.key];
        var onClick = function () {
            handlerChange(!selected, item);
        };
        return (react_1.default.createElement(MultiSelectMenuItem_1.default, { key: key, item: renderItem ? renderItem(item) : item, onClick: onClick, style: style, selected: selected, showCheckbox: showCheckbox, classes: classes }));
    };
    return RowRenderer;
});
